
import React from 'react';
import { Star } from 'lucide-react';

const TourOverview: React.FC = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            <div className="md:col-span-2">
              <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-6 text-[#3E2723]">
                Discover the Lower East Side's Feline Past
              </h2>
              <div className="prose prose-lg text-[#3E2723]/90 font-montserrat">
                <p className="mb-4">
                  Step into the lively and storied streets of the Lower East Side, where the tales of tenacious cats from the 1800s and early 1900s intertwine with the neighborhood's gritty past and legendary characters. This 1.5-mile walking tour dives into the surprising ways historical felines left their paw prints on the city's colorful past.
                </p>
                <p className="mb-4">
                  You'll uncover wild stories of feline bar flies in dive joints like Suicide Hall and The Flea Bag, heroic cats who saved lives from burning buildings, and even a "feline house of detention." From Houdini's first performance to NYC's first cat show, and from the Ramones at CBGB's to a cowboy lassoing a cat to safety—this tour is packed with the kind of quirky, can't-believe-it-happened-here stories that make the Lower East Side so special.
                </p>
                <p className="mb-4">
                  Our tour ends near Meow Parlour, where you can independently visit to sip a drink and hang out with some adoptable cats (separate reservation required). You might even leave with a new furry friend!
                </p>
                
                {/* Cat Cafe Clarification */}
                <div className="bg-[#FAF2E8] p-4 rounded-lg border border-[#C58B65]/20 mb-4">
                  <p className="text-[#8B4513] font-medium">
                    <strong>Tour Note:</strong> Want to meet living, breathing, purring cats after our history lesson? Our LES Tour concludes near Meow Parlour. Just remember, you'll need your own reservation—we're amazing at historical cat tales, but haven't mastered the art of cat cafe reservations!
                  </p>
                </div>
                
                {/* Bring your own cat note */}
                <div className="bg-[#FAF2E8] p-4 rounded-lg border border-[#C58B65]/20 mb-4">
                  <p className="text-[#8B4513] font-medium">
                    Feel free to bring your own cat along for the historical adventure! Well-behaved felines on harnesses are welcome to join as we explore the paths where their ancestors once roamed.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Sticky Booking Card */}
            <div className="md:sticky md:top-24">
              <div className="bg-[#FAF2E8] p-6 rounded-lg border border-[#C58B65]/20 shadow-md">
                <h3 className="font-playfair font-bold text-xl mb-4 text-[#3E2723] text-center">
                  Book Your Spot
                </h3>
                <p className="text-center mb-4 text-[#3E2723]/80">
                  $40 per person
                </p>
                <div className="flex justify-center mb-4">
                  <div className="flex items-center">
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <Star size={14} className="text-[#D4AF37]" aria-hidden="true" />
                    <span className="ml-2 text-sm text-[#3E2723]/80">
                      (98% 5-star reviews)
                    </span>
                  </div>
                </div>
                <a 
                  href="#book-now"
                  className="bg-[#D32F2F] text-white py-3 px-4 rounded font-montserrat font-semibold text-center block hover:bg-[#C62828] transition-colors"
                >
                  Check Available Dates
                </a>
                <p className="text-xs text-center mt-4 text-[#3E2723]/60">
                  Secure booking · Instant confirmation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourOverview;
